import React from 'react'
import './LoadingOverlay.css'

/**
 * 전체 화면 로딩 오버레이 컴포넌트
 */
function LoadingOverlay({ isLoading, message, progress, subMessage }) {
  if (!isLoading) return null

  return (
    <div className="loading-overlay">
      <div className="loading-modal">
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
        </div>
        
        <div className="loading-content">
          <h3>{message || '처리 중...'}</h3>
          
          {subMessage && (
            <p className="loading-submessage">{subMessage}</p>
          )}
          
          {progress !== undefined && (
            <div className="loading-progress-bar">
              <div 
                className="loading-progress-fill" 
                style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
              />
            </div>
          )}
          
          {progress !== undefined && (
            <p className="loading-progress-text">{Math.round(progress)}%</p>
          )}
        </div>
      </div>
    </div>
  )
}

export default LoadingOverlay